import { render, staticRenderFns } from "./sub.vue?vue&type=template&id=b9043420&scoped=true&"
import script from "./sub.vue?vue&type=script&lang=ts&"
export * from "./sub.vue?vue&type=script&lang=ts&"
import style0 from "./sub.vue?vue&type=style&index=0&id=b9043420&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9043420",
  null
  
)

export default component.exports